import React from 'react';

export default function ShowMoreButton({ expanded, onClick, totalCount, visibleCount, variant = 'default' }) {
    if (totalCount <= visibleCount) return null;

    const remaining = totalCount - visibleCount;

    const baseClasses = 'group inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full text-[0.9375rem] font-semibold tracking-wide transition-all duration-300 ease-standard cursor-pointer select-none';

    const variants = {
        default: `bg-surface-container text-on-surface border border-outline-variant hover:bg-primary-container hover:text-on-primary-container hover:border-primary/30 hover:shadow-2 hover:-translate-y-0.5`,
        dark: `bg-white/[0.06] text-white/80 border border-white/[0.1] hover:bg-white/[0.12] hover:text-white hover:border-white/[0.2] hover:shadow-[0_4px_24px_rgba(255,255,255,0.06)] hover:-translate-y-0.5`,
        youtube: `bg-white/[0.06] text-inverse-on-surface border border-white/[0.08] hover:bg-accent-red/20 hover:text-accent-red hover:border-accent-red/30 hover:shadow-[0_4px_24px_rgba(233,69,96,0.15)] hover:-translate-y-0.5`,
        photo: `bg-white/[0.06] text-[#f5f5f5]/80 border border-white/[0.08] hover:bg-[#00bcd4]/15 hover:text-[#00bcd4] hover:border-[#00bcd4]/30 hover:shadow-[0_4px_24px_rgba(0,188,212,0.15)] hover:-translate-y-0.5`,
    };

    return (
        <div className="flex justify-center mt-10 reveal">
            <button className={`${baseClasses} ${variants[variant]}`} onClick={onClick}>
                {expanded ? (
                    <>
                        <span>Show Less</span>
                        <i className="fa-solid fa-chevron-up text-xs transition-transform duration-300 group-hover:-translate-y-0.5" />
                    </>
                ) : (
                    <>
                        <span>Show More</span>
                        <span className="show-more-badge inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full text-xs font-bold">
                            +{remaining}
                        </span>
                        <i className="fa-solid fa-chevron-down text-xs transition-transform duration-300 group-hover:translate-y-0.5" />
                    </>
                )}
            </button>
        </div>
    );
}
